import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { UIProvider } from "@/context/UIContext";
import { KidsProvider, useKids } from "@/context/KidsContext";
import { DetailModal } from "@/components/DetailModal";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import Browse from "@/pages/Browse";
import Live from "@/pages/Live";
import MyList from "@/pages/MyList";
import SearchPage from "@/pages/SearchPage";
import Watch from "@/pages/Watch";
import Plans from "@/pages/Plans";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import KidsHome from "@/pages/KidsHome";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Cookies from "@/pages/Cookies";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import ResetPassword from "@/pages/ResetPassword";
import Profile from "@/pages/Profile";

function AppRouter() {
  const location = useLocation();
  const { kidsMode } = useKids();

  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  if (kidsMode) {
    return (
      <Routes>
        <Route path="/watch/:id" element={<Watch />} />
        <Route path="*" element={<KidsHome />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/movies" element={<Browse mode="movies" />} />
      <Route path="/series" element={<Browse mode="series" />} />
      <Route path="/originals" element={<Browse mode="originals" />} />
      <Route path="/kids" element={<Browse mode="kids" />} />
      <Route path="/live" element={<Live />} />
      <Route path="/my-list" element={<MyList />} />
      <Route path="/search" element={<SearchPage />} />
      <Route path="/watch/:id" element={<Watch />} />
      <Route path="/plans" element={<Plans />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/cookies" element={<Cookies />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/about" element={<About />} />
      <Route path="/login" element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <UIProvider>
          <KidsProvider>
            <AppRouter />
            <DetailModal />
            <Toaster position="top-center" theme="dark" richColors />
          </KidsProvider>
        </UIProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
